<template>
    <swipeable-bottom-sheet id="sheet" ref="swipeableBottomSheet">
        <social-share :show-dialog.sync="showDialog"
                      :card.sync="card"
                      :loan-id="card._id"
                      :borr="card.borrower.firstN"
                      :headline="card.headline"
        ></social-share>
        <loan-offer :make-offer.sync="makeOffer"
                    :borr-tel="card.borrower.tel"
                    :borr-first-n="card.borrower.firstN"
        ></loan-offer>
        <get-trust-popup :get-trust.sync="getTrust"></get-trust-popup>
        <div class="level is-mobile headline">
            <div class="level-left">
                <p class="is-size-5">{{card.borrower.firstN}}</p>
            </div>
            <div class="level-right">
                <p>
                    <span class="is-size-7">{{card.currency}}</span>  <span class="title is-size-4">{{card.principal | number}}</span>
                </p>
            </div>
        </div>
        <div class="loan_details_body">
            <div>
                <figure class="image is-96x96 dp">
                    <img class="is-rounded" :src='card.borrower.dp'>
                </figure>
                <p class="is-size-4">{{card.borrower.firstN}} {{card.borrower.lastN}}</p>
            </div>
            <div style="margin: 12px">
                <p>{{card.interest}}% interest</p>
                <p>{{card.due}}</p>
            </div>
            <div class="loan-controls">
                <div class="columns is-mobile is-variable is-1">
                    <div class="column">
                        <div class="loan-options columns is-mobile is-variable is-1">
                            <div class="column loan-option" @click="makeOffer = true;">
                                <md-icon class="icon">how_to_vote</md-icon><br>
                                <p class="is-size-7">Make a Loan Offer</p>
                            </div>
                            <div class="column" @click="getTrust = true;">
                                <md-icon class="icon">star_half</md-icon><br>
                                <p class="is-size-7">Get {{card.borrower.firstN}}'s Trust Rating</p>
                            </div>
                        </div>
                    </div>
                    <div class="column is-narrow">
                        <md-button @click="openShare" class="md-icon-button md-raised">
                            <md-icon >share</md-icon>
                        </md-button>
                    </div>
                </div>
            </div>
            <div class="card-body" v-if="card.body">
                <p class="title is-size-4">{{card.headline}}</p>
                <p>{{card.body}}</p>
            </div>
        </div>
    </swipeable-bottom-sheet>
</template>

<script>
    import { SwipeableBottomSheet } from "vue-swipeable-bottom-sheet";
    import BButton from "buefy/src/components/button/Button";
    import SocialShare from "./social-share";
    import LoanOffer from "./loan-offer";
    import GetTrustPopup from "./get-trust-popup";

    export default {
        name: "vue-swipe-component",
        props: ['card'],
        data() {
            return {
                showDialog: false,
                makeOffer: false,
                getTrust: false
            }
        },
        components: {GetTrustPopup, LoanOffer, SocialShare, BButton, SwipeableBottomSheet},
        methods: {
            openShare() {
                this.showDialog = true;
                this.$emit('update:loan', this.$props.card)
            }
        }
    }
</script>

<style scoped>
    .headline {
        padding: 2.8%;
        height: 20%;
    }

    .dp {
        width: 100vw;
        margin-left: auto;
        margin-right: auto;
    }

    .loan-controls {
        margin: 36px 21px;
    }

    .loan-options {
        box-shadow: rgba(23, 55, 87, 0.1) 0px 3px 36px 0px, rgba(0, 0, 0, 0.07) 0px 5px 15px 0px;
        padding: 4px;
        border-radius: 8px;
    }

    .loan-option {
        border-right :1px solid rgba(0,0,0,0.16);
    }

    .icon {
        font-size: 36px !important;
        margin-bottom: 4px !important;
        color: #00a86b !important;
    }

    .card-body {
        margin: 48px 14px 136px 14px;
        padding: 18px;
        background: #f0faf0;
        border-radius: 8px;
        text-align: left;
    }
</style>